import { render } from "./MainTemporarySales.vue?vue&type=template&id=2d7c022e&scoped=true"
import script from "./MainTemporarySales.vue?vue&type=script&lang=js"
export * from "./MainTemporarySales.vue?vue&type=script&lang=js"

import "./MainTemporarySales.vue?vue&type=style&index=0&id=2d7c022e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7c022e"]])

export default __exports__